// extracted by mini-css-extract-plugin
export default {"columnSpace":"FoundationParameters_columnSpace__t7eQV"};